import React, { useCallback, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Box, Modal, PlusRoundIcon, RawButton, Text, useResponsive } from '@common-fe/common-fe';

import AddMoreFundsContent from './AddMoreFundsContent';

interface Props {
  accountId: string;
  excludeIds: string[];
}

const AddMoreFunds: React.FC<Props> = ({ accountId, excludeIds }) => {
  const { isMobile } = useResponsive();
  const [isDisplayed, setDisplayed] = useState(false);
  const { t } = useTranslation();
  // return (
  //   <Box style={{position: 'relative'}}>

  //     <Text>{t('Add Fund')}</Text>
  //     <PlusRoundIcon />

  //     {isDisplayed && (
  //       <Box>
  //       </Box>
  //     )}
  //   </Box>
  // );
  const handleToggle = useCallback(() => {
    setDisplayed(!isDisplayed);
  }, [isDisplayed]);

  if (isMobile) {
    return (
      <>
        <RawButton data-testid="AddMoreFunds_button" onClick={handleToggle}>
          <Box direction="row" align="center" justify="center">
            <Text color="buttonPrimary">{t('Add Fund')}</Text>
            <Box margin={{ left: 'xxs' }}>
              <PlusRoundIcon color="buttonPrimary" />
            </Box>
          </Box>
        </RawButton>

        <Modal visible={isDisplayed} onSetVisible={handleToggle} contentStyle={{ padding: 0 }}>
          <AddMoreFundsContent
            isModalMode
            excludeIds={excludeIds}
            accountId={accountId}
            onClose={handleToggle}
          />
        </Modal>
      </>
    );
  }
  return (
    <Box style={{ position: 'relative' }} direction="row" align="center">
      <RawButton data-testid="AddMoreFunds_button" onClick={handleToggle}>
        <Box direction="row" align="center" justify="center">
          <Text color="buttonPrimary">{t('Add Fund')}</Text>
          <Box margin={{ left: 'xxs' }}>
            <PlusRoundIcon color="buttonPrimary" />
          </Box>
        </Box>
      </RawButton>
      {isDisplayed && (
        <AddMoreFundsContent excludeIds={excludeIds} accountId={accountId} onClose={handleToggle} />
      )}
    </Box>
  );
};

export default AddMoreFunds;
